import React from 'react';
import { useSelector } from 'react-redux';

import { SpinoffCard } from './SpinoffCard';
import { SpinoffCardPlaceholder } from './SpinoffCardPlaceholder';

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';
import { getVideoPlans } from 'js/src/data/video-planner';
import { LuminaryContextProvider } from 'js/src/luminary';

const NUM_PLACEHOLDERS_TO_SHOW = 3;
const PLACEHOLDER_SPINOFFS = Array.from({ length: NUM_PLACEHOLDERS_TO_SHOW }).map((_, index) => (
    <SpinoffCardPlaceholder key={index} />
));

interface SpinoffsListStageProps {
    isError: boolean;
    isFetching: boolean;
    onRetryGetSpinoffs: () => void;
    onShowPreview: (planId: string) => void;
    savedPlanIds: Set<string>;
}

export const SpinoffsListStage = ({
    isError,
    isFetching,
    onRetryGetSpinoffs,
    onShowPreview,
    savedPlanIds,
}: SpinoffsListStageProps) => {
    const videoPlans = useSelector(getVideoPlans);

    return (
        <>
            <div className="mb-l5-16 font-l5 font-l5--small--medium text-align-left">
                These videos were automatically generated from your content, offering different ways
                to share your message.
            </div>
            {isError ? (
                <div className="spinoffs-modal__error d-flex flex-column align-items-center">
                    <span className="font-l5 font-l5--regular--medium color-grey-600 d-flex align-items-center mb-l5-8">
                        <i className="material-symbols-outlined text-danger me-l5-4">error</i>
                        Failed to load spinoffs
                    </span>
                    <Button
                        text="Try again"
                        onClick={onRetryGetSpinoffs}
                        variant={BUTTON_VARIANTS.LINK}
                        color={BUTTON_COLORS.PRIMARY}
                        disabled={isFetching}
                    />
                </div>
            ) : (
                <div className="spinoffs-modal__list">
                    {videoPlans.length
                        ? videoPlans.map((plan) => (
                              <LuminaryContextProvider
                                  key={plan.id}
                                  minDimensionResolution={
                                      window.screen && window.screen.availWidth <= 900 ? 300 : 500
                                  }
                                  name="SpinoffCard"
                                  fetchMedia
                                  fetchFonts
                                  fetchAudio
                                  autoDraw
                              >
                                  <SpinoffCard
                                      key={plan.id}
                                      videoPlanId={plan.id}
                                      onShowPreview={onShowPreview}
                                      isSaved={savedPlanIds.has(plan.id)}
                                  />
                              </LuminaryContextProvider>
                          ))
                        : PLACEHOLDER_SPINOFFS}
                </div>
            )}
        </>
    );
};
